import { useCallback, useEffect, useState } from 'react';

function normalize(hash) {
  const raw = (hash || '').replace(/^#/, '');
  const path = raw.startsWith('/') ? raw : `/${raw}`;
  const cleaned = path.replace(/\/+$/, '');
  return cleaned === '' ? '/' : cleaned;
}

export function useHashRoute() {
  const [route, setRoute] = useState(() => normalize(window.location.hash));

  useEffect(() => {
    function onChange() {
      setRoute(normalize(window.location.hash));
    }
    window.addEventListener('hashchange', onChange);
    return () => window.removeEventListener('hashchange', onChange);
  }, []);

  const navigate = useCallback((path) => {
    const next = normalize(`#${path}`);
    const nextHash = `#${next}`;
    if (window.location.hash !== nextHash) {
      window.location.hash = nextHash;
    } else {
      setRoute(next);
    }
  }, []);

  return { route, navigate };
}

